import type { ExternalOperatorShippingDetail } from '../services/externalOperatorShippings.endpoints';
import type { ColumnConfig } from '@/components/table/Table';
import type { MarkerData } from '@/components/maps';
import { formatDate } from '@/utils/dates';

const EMPTY = 'N/A';

const text = (value?: string | null, fallback: string = EMPTY): string =>
  value && String(value).trim() ? String(value) : fallback;

export const getShippingGeneralColumns = (
  shipping: ExternalOperatorShippingDetail,
  deliveryMarker: MarkerData | null,
  onShowDeliveryMap: () => void
): ColumnConfig[] => [
  {
    label: 'ID Externo',
    field: 'externalId',
    render: () => <span className='text-sm'>{text(shipping.externalId)}</span>,
  },
  {
    label: 'Operador logístico',
    field: 'logisticOperator',
    render: () => (
      <span className='text-sm'>{text(shipping.logisticOperator)}</span>
    ),
  },
  {
    label: 'Comercio',
    field: 'commerce',
    render: () => <span className='text-sm'>{text(shipping.commerce)}</span>,
  },
  {
    label: 'Nombre del cliente',
    field: 'recipient',
    render: () => <span className='text-sm'>{text(shipping.recipient)}</span>,
  },
  {
    label: 'Teléfono del cliente',
    field: 'phone',
    render: () => (
      <span className='text-sm'>
        {text(shipping.recipientPhoneNumber, 'Sin teléfono')}
      </span>
    ),
  },
  {
    label: 'Dirección de entrega',
    field: 'delivery',
    render: () =>
      deliveryMarker ? (
        <button
          onClick={onShowDeliveryMap}
          className='text-sm text-blue-600 hover:text-blue-800 hover:underline cursor-pointer text-left'
        >
          {text(shipping.deliveryAddress)}
        </button>
      ) : (
        <span className='text-sm'>{text(shipping.deliveryAddress)}</span>
      ),
  },
  {
    label: 'Detalle de entrega',
    field: 'deliveryDetails',
    render: () => (
      <span className='text-sm'>{text(shipping.deliveryDetails)}</span>
    ),
  },
  {
    label: 'Fecha de ingreso',
    field: 'entry',
    render: () => (
      <span className='text-sm'>
        {shipping.createdAt ? formatDate(shipping.createdAt) : EMPTY}
      </span>
    ),
  },
];
